import axios from './APIClient';
import axios2 from './APIClient2';
import * as R from 'ramda';

import { notify } from './notify';
import { AXIOSFAILED } from '../constants/actions';
import { trackPromise } from 'react-promise-tracker';
import RESETAPP from '../utils/resetApp';

function createMessageFromError(errs) {
  let acc = '';
  const keyPlusValue = (value, key) => (acc = acc + key + ':' + value + '\n');
  R.forEachObjIndexed(keyPlusValue)(errs);
  return acc;
}

export const masterApi = async (method, url, data, config, version, ...args) => {
  method = method.toLowerCase();
  let res = null;
  try {
    res = version === 1 ? await trackPromise(axios[method](url, data, ...args)) : await trackPromise(axios2[method](url, data, ...args));
    return res.data;
  } catch (error) {
    const { response } = error;
    if (!response) return { status: AXIOSFAILED };

    notify.warning(response?.data?.message);
    const me = createMessageFromError(response?.data?.errors);
    notify.info(me);
    console.error(response);
    if (response.status === 401) {
      RESETAPP();
    }
    return { ...response, status: AXIOSFAILED };
  }
};

export const catcher = async (
  method,
  url,
  inData,
  config,
  version,
  mess = true,
  ...args
) => {
  const res = await masterApi(method, url, inData, config, version, ...args);
  // mess && res.message && notify.def(res.message);
  if (!res) return { data: null };

  const { status, data, message } = res;

  switch (status) {
    default:
      return res;
  }
};

let curCatcher = R.curry(catcher);

export const masterApiNoLoader = async (method, url, data, config, version, ...args) => {
  method = method.toLowerCase();
  let res = null;
  try {
    res = version === 1 ? await axios[method](url, data, ...args) : await axios2[method](url, data, ...args) ;
    return res.data;
  } catch (error) {
    const { response } = error;
    if (!response) return { status: AXIOSFAILED };

    notify.warning(response?.data?.message);
    const me = createMessageFromError(response?.data?.errors);
    notify.info(me);
    console.error(response);
    return { ...response, status: AXIOSFAILED };
  }
};
export const catcherNoLoader = async (
  method,
  url,
  inData,
  config,
  version = 1,
  mess = true,
  ...args
) => {
  const res = await masterApiNoLoader(method, url, inData, config, version, ...args);
  mess && res.message && notify.def(res.message);
  if (!res) return { data: null };

  const { status, data, message } = res;

  switch (status) {
    default:
      return res;
  }
};

// export const curCatcherNoLoader = R.curry(catcher);

export default curCatcher;
